import { createContext, use } from "react";
import type { StepperContextType } from "../types";

export const StepperContext = createContext<StepperContextType>(
  {} as StepperContextType,
);

export const useStepperContext = () => use(StepperContext);
